module.exports = {"id":"190277","name":"Eyong Enoh","rating":"72","photo":"./data/images/photos/0/190277.png","club":{"name":"Willem II","logo":"./data/images/clubs/WillemII.png"},"positions":["MDC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EyongEnoh0.json
// module id = 1315
// module chunks = 0